import type { Theme } from "../types";

/** Brand themes + mint-light / aurora pair */
export const bundle04: Theme[] = [
  {
    colors: {
      accent: "oklch(0.3 0.05 210)",
      accentForeground: "oklch(0.99 0 0)",
      background: "oklch(0.15 0.03 215)",
      border: "oklch(1 0 0 / 8%)",
      card: "oklch(0.19 0.03 215)",
      cardForeground: "oklch(0.99 0 0)",
      chartColors: [
        "oklch(0.8 0.22 155)",
        "oklch(0.7 0.15 210)",
        "oklch(0.6 0.2 300)",
        "oklch(0.75 0.18 85)",
        "oklch(0.65 0.22 30)",
      ],
      destructive: "oklch(0.65 0.2 15)",
      foreground: "oklch(0.99 0 0)",
      input: "oklch(1 0 0 / 12%)",
      muted: "oklch(0.25 0.04 210)",
      mutedForeground: "oklch(0.55 0.03 210)",
      popover: "oklch(0.19 0.03 215)",
      popoverForeground: "oklch(0.99 0 0)",
      primary: "oklch(0.8 0.22 155)",
      primaryForeground: "oklch(0.12 0.03 215)",
      ring: "oklch(0.8 0.22 155)",
      secondary: "oklch(0.25 0.04 210)",
      secondaryForeground: "oklch(0.99 0 0)",
      sidebar: "oklch(0.12 0.03 215)",
      sidebarAccent: "oklch(0.3 0.05 210)",
      sidebarAccentForeground: "oklch(0.99 0 0)",
      sidebarBorder: "oklch(1 0 0 / 8%)",
      sidebarForeground: "oklch(0.99 0 0)",
      sidebarPrimary: "oklch(0.8 0.22 155)",
      sidebarPrimaryForeground: "oklch(0.12 0.03 215)",
      sidebarRing: "oklch(0.8 0.22 155)",
    },
    isDark: true,
    label: "Aurora",
    name: "aurora",
    pair: "mint-light",
    swatches: ["#011926", "#00e980", "#245c69", "#000c13"],
  },
  {
    colors: {
      accent: "oklch(0.87 0.035 128)",
      accentForeground: "oklch(0.28 0.04 145)",
      background: "oklch(0.96 0.015 128)",
      border: "oklch(0.85 0.03 128)",
      card: "oklch(0.96 0.015 128)",
      cardForeground: "oklch(0.28 0.04 145)",
      chartColors: [
        "oklch(0.55 0.1 140)",
        "oklch(0.65 0.12 160)",
        "oklch(0.7 0.08 100)",
        "oklch(0.5 0.08 180)",
        "oklch(0.75 0.1 120)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.28 0.04 145)",
      input: "oklch(0.85 0.03 128)",
      muted: "oklch(0.9 0.025 128)",
      mutedForeground: "oklch(0.52 0.04 140)",
      popover: "oklch(0.97 0.012 128)",
      popoverForeground: "oklch(0.28 0.04 145)",
      primary: "oklch(0.55 0.1 140)",
      primaryForeground: "oklch(0.97 0.01 128)",
      ring: "oklch(0.55 0.1 140)",
      secondary: "oklch(0.9 0.025 128)",
      secondaryForeground: "oklch(0.28 0.04 145)",
      sidebar: "oklch(0.94 0.018 128)",
      sidebarAccent: "oklch(0.87 0.035 128)",
      sidebarAccentForeground: "oklch(0.28 0.04 145)",
      sidebarBorder: "oklch(0.85 0.03 128)",
      sidebarForeground: "oklch(0.28 0.04 145)",
      sidebarPrimary: "oklch(0.55 0.1 140)",
      sidebarPrimaryForeground: "oklch(0.97 0.01 128)",
      sidebarRing: "oklch(0.55 0.1 140)",
    },
    isDark: false,
    label: "Mint",
    name: "mint-light",
    pair: "aurora",
    swatches: ["#eef1e4", "#7a9a6e", "#3d5a3e", "#c8d5b9"],
  },
  {
    colors: {
      accent: "oklch(0.29 0.03 255)",
      accentForeground: "oklch(0.96 0 0)",
      background: "oklch(0.16 0.02 255)",
      border: "oklch(1 0 0 / 8%)",
      card: "oklch(0.19 0.022 255)",
      cardForeground: "oklch(0.96 0 0)",
      chartColors: [
        "oklch(0.57 0.22 25)",
        "oklch(0.55 0.17 240)",
        "oklch(0.78 0.14 85)",
        "oklch(0.65 0.15 295)",
        "oklch(0.7 0.12 155)",
      ],
      destructive: "oklch(0.55 0.17 240)",
      foreground: "oklch(0.96 0 0)",
      input: "oklch(1 0 0 / 12%)",
      muted: "oklch(0.24 0.026 255)",
      mutedForeground: "oklch(0.52 0.04 250)",
      popover: "oklch(0.19 0.022 255)",
      popoverForeground: "oklch(0.96 0 0)",
      primary: "oklch(0.57 0.22 25)",
      primaryForeground: "oklch(0.13 0.02 255)",
      ring: "oklch(0.57 0.22 25)",
      secondary: "oklch(0.24 0.026 255)",
      secondaryForeground: "oklch(0.96 0 0)",
      sidebar: "oklch(0.13 0.02 255)",
      sidebarAccent: "oklch(0.29 0.03 255)",
      sidebarAccentForeground: "oklch(0.96 0 0)",
      sidebarBorder: "oklch(1 0 0 / 8%)",
      sidebarForeground: "oklch(0.96 0 0)",
      sidebarPrimary: "oklch(0.57 0.22 25)",
      sidebarPrimaryForeground: "oklch(0.13 0.02 255)",
      sidebarRing: "oklch(0.57 0.22 25)",
    },
    isDark: true,
    label: "Spiderman",
    name: "spiderman",
    pair: "spiderman",
    swatches: ["#0d1219", "#e23636", "#0476f2", "#0b1c2e"],
  },
];
